import React from 'react';
import { IProduct } from '@mybestbrands/types';
import styles from '../style.module.scss';

interface ColorLabelProps {
  colorVariantItems?: IProduct[];
}

const ColorLabel = ({ colorVariantItems }: ColorLabelProps) => {
  if (!colorVariantItems) return null;
  const visibleColors = colorVariantItems.slice(0, 2);
  const remainingColorsCount = colorVariantItems.length - 2;

  return (
    <div className={`px-1 ${styles['colorLabel']}`} style={{ height: '24px' }}>
      {visibleColors.map((product, index) => {
        const color = product.colorTags[0]; // Assuming first color is the primary one
        return (
          <div
            key={index}
            style={{
              backgroundColor: color, // Adjust if color is black
              width: '15px',
              height: '15px',
              borderRadius: '50%',
              border: '1px solid #ccc',
              marginLeft: index === 0 ? '0' : '-0.5rem', // Overlapping effect
              zIndex: index, // Ensure proper stacking of circles
            }}
          />
        );
      })}
      {remainingColorsCount > 0 && (
        <div
          className={styles['colorCounter']}
          style={{
            height: '24px',
            color: '#000',
          }}>
          +{remainingColorsCount}
        </div>
      )}
    </div>
  );
};

export default ColorLabel;
